<template>
  <div class="packaging-modificators-group">
    <div class="qrw-label-lg bold v1-grey-6-color">
      {{ price_group.name || $t("modificators_settings.name_ph") }}
    </div>
    <BaseDivider color="v1-grey-3" />
    <template v-for="item in price_group.items">
      <BaseRadioButton
        bgColor="var(--green-6-color)"
        :value="isSelected(item._id)"
        @input="toggleItem(item._id)"
        :key="item._id"
        v-if="price_group.single_select && price_group.min_count == 1 && price_group.max_count == 1"
      >
        {{ item.name }}
      </BaseRadioButton>
      <BaseCheckbox
        :value="isSelected(item._id)"
        @input="toggleItem(item._id)"
        :key="item._id"
        v-else
      >
        {{ item.name }}
      </BaseCheckbox>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    price_group: Object,
    value: Array,
  },
  methods: {
    getSelectedIndex(item_id) {
      return this.value.indexOf(item_id);
    },
    isSelected(item_id) {
      return this.getSelectedIndex(item_id) !== -1;
    },
    toggleItem(item_id) {
      const idx = this.getSelectedIndex(item_id);

      if (idx === -1) {
        if (
          this.price_group.max_count &&
          this.value.length + 1 > this.price_group.max_count
        )
        {
          this.$emit('input', [item_id]);
          return;
        }

          if (this.price_group.single_select || this.price_group.max_count)

        this.$emit("input", [...this.value, item_id]);
      } else {
        if (
          this.price_group.min_count &&
          this.value.length - 1 < this.price_group.min_count
        )
          return;

        this.$emit(
          "input",
          this.value.filter((v) => v != item_id)
        );
      }
    },
  },
};
</script>

<style scoped>
.packaging-modificators-group {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}
</style>